(function (sr) {
    let debounce = function (func, threshold, execAsap) {
        let timeout;
        return function debounced() {
            let obj = this, args = arguments;

            function delayed() {
                if (!execAsap)
                    func.apply(obj, args);
                timeout = null;
            };
            if (timeout)
                clearTimeout(timeout);
            else if (execAsap)
                func.apply(obj, args);

            timeout = setTimeout(delayed, threshold || 100);
        };
    };
    // smartresize
    window[sr] = function (fn) {
        return fn ? this.addEventListener('resize', debounce(fn)) : this.dispatchEvent(new Event(sr));
    };
})('smartresize');

let globalVar = {};

const refresh_size_queries = () => {
    let classes = [];
    let scrollbarwidth = getScrollbarWidth();
    let window_width = window.innerWidth;
    let window_height = window.innerHeight;

    globalVar.is_phone = (window_width < 768);
    globalVar.is_mobile = (window_width < 992);
    globalVar.is_tablet_portrait = (window_width >= 768 && window_width < 992);
    globalVar.is_tablet = globalVar.is_tablet_portrait || globalVar.is_tablet_landscape;
    globalVar.is_desktop = (window_width >= 992);
    globalVar.is_desktop_medium = (window_width < 1500);
    globalVar.is_desktop_large = (window_width >= 1200);
    globalVar.is_desktop_larger = (window_width >= 1500);

    if (globalVar.is_phone) {
        classes.push('mq_phone');
    }
    if (globalVar.is_mobile) {
        classes.push('mq_mobile');
    }
    if (globalVar.is_tablet_portrait) {
        classes.push('mq_tablet_portrait');
    }
    if (globalVar.is_tablet_landscape) {
        classes.push('mq_tablet_landscape');
    }
    if (globalVar.is_tablet) {
        classes.push('mq_tablet');
    }
    if (globalVar.is_desktop) {
        classes.push('mq_desktop');
    }
    if (globalVar.is_desktop_large) {
        classes.push('mq_desktop_large');
    }
    if (globalVar.is_desktop_larger) {
        classes.push('mq_desktop_larger');
    }

    document.documentElement.classList.remove('mq_phone', 'mq_mobile', 'mq_tablet_portrait', 'mq_tablet_landscape', 'mq_tablet', 'mq_desktop');

    classes.forEach(function (className) {
        document.documentElement.classList.add(className);
    });

    function getScrollbarWidth() {
        var outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
        outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps
        document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
        // add innerdiv
        var inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        // remove divs
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    }

    return globalVar;
}

const hotel_languages = () => {
    const languages = document.querySelector('#languages');
    const lang_mobile = document.querySelector('.lang_mobile');

    languages.addEventListener('click', () => {
        document.querySelectorAll('.other_languages').forEach(el => {
            el.classList.toggle('fade-active');
            if (el.classList.contains('fade-active')) {
                el.style.display = 'block';
            } else {
                el.style.display = 'none';
            }
        });
    });

    if (lang_mobile) {
        lang_mobile.addEventListener('click', () => {
            document.querySelectorAll('.other_lang_mobile').forEach(el => {
                el.classList.toggle('fade-active');
                if (el.classList.contains('fade-active')) {
                    el.style.display = 'block';
                } else {
                    el.style.display = 'none';
                }
            });
        });
    }

    // document.addEventListener('mouseup', (e) => {
    //     const currentLanguage = document.querySelector('.current_language');
    //     if (!currentLanguage.contains(e.target)) {
    //         document.querySelectorAll('.other_languages').forEach(el => {
    //             el.classList.remove('show');
    //             el.style.display = 'none';
    //         });
    //     }
    // });
    //
    // document.addEventListener('mouseup', (e) => {
    //     const currentLanguage = document.querySelector('.current_language');
    //     const otherLanguages = document.querySelectorAll('.other_languages');
    //
    //     if (!currentLanguage.contains(e.target) && e.target !== currentLanguage) {
    //         otherLanguages.forEach(el => {
    //             el.classList.remove('show');
    //
    //             const fadeOut = (element) => {
    //                 let opacity = 1;
    //                 const timer = setInterval(() => {
    //                     if (opacity <= 0.1) {
    //                         clearInterval(timer);
    //                         element.style.display = 'none';
    //                         element.style.opacity = '';
    //                     }
    //                     element.style.opacity = opacity;
    //                     opacity -= opacity * 0.1;
    //                 }, 10);
    //             };
    //
    //             fadeOut(el);
    //         });
    //     }
    // });
}

const headerPosition = () => {
    const header = document.querySelector('#header');
    const slideshow = document.querySelector('#slideshow-1');

    if (slideshow) {
        ScrollTrigger.create({
            trigger: "#slideshow-1",
            start: "bottom top",
            end: "bottom top",
            onEnter: () => addClassHeader(),
            onLeaveBack: () => removeClassHeader(),
        });

        const addClassHeader = () => {
            header.classList.add('fixed');
        }

        const removeClassHeader = () => {
            header.classList.remove('fixed');
        }
    } else {
        header.classList.add('fixed');
    }
}

const openingSidebarSubmenu = () => {
    const isDesktop = globalVar.is_desktop;

    if (isDesktop) {
        const menuItemNoSubmenu = document.querySelectorAll('.menu_sidebar_inner_left ul.menu > li:not(.menu-item-has-children) > a');
        const menuItem = document.querySelectorAll('.menu_sidebar_inner_left ul.menu > li.menu-item-has-children > a');

        if (menuItem.length !== 0) {
            menuItem.forEach((element) => {
                const tl = gsap.timeline({ paused: true, ease: "power3.inOut" });
                const submenuItem = element.nextElementSibling;

                tl.fromTo(submenuItem, {
                    x: -50,
                    pointerEvents: "none",
                    opacity: 0,
                }, {
                    duration: 0.3,
                    delay: 0.3,
                    pointerEvents: "auto",
                    x: 0,
                    opacity: 1,
                });

                element.addEventListener('mouseenter', () => {
                    tl.play();
                });

                element.addEventListener('mouseleave', () => {
                    menuItem.forEach(item => {
                        if (item !== element) {
                            item.addEventListener('mouseenter', () => {
                                tl.reverse();
                            });
                        }
                    });
                });

                menuItemNoSubmenu.forEach(item => {
                    item.addEventListener('mouseenter', () => {
                        tl.reverse();
                    });
                });
            });
        }
    } else {
        const submenuMobile = document.querySelectorAll('#menu_sidebar_wrap_mobile ul.menu > li.menu-item-has-children > a');

        submenuMobile.forEach(item => {
            const span = document.createElement('span');
            span.className = 'more_li';
            item.insertAdjacentElement('afterend', span);
        });

        const button = document.querySelectorAll("#menu_sidebar_wrap_mobile ul.menu > li.menu-item-has-children > .more_li");
        const parent = document.querySelectorAll("li.menu-item-has-children");
        const submenu = document.querySelectorAll("ul.sub-menu");
        const mClass = "open";

        if (submenu) {
            submenu.forEach(item => {
                item.style.display = 'none';
            });
        }

        if (button) {
            button.forEach(btn => {
                btn.addEventListener('click', function () {
                    const currentParent = this.closest('li.menu-item-has-children');

                    if (!currentParent.classList.contains('open')) {
                        parent.forEach(p => {
                            p.classList.remove(mClass);
                            p.querySelectorAll('ul.sub-menu').forEach(s => {
                                s.style.display = 'none';
                            });
                        });

                        const currentSubmenu = currentParent.querySelector('ul.sub-menu');

                        const fadeIn = (element, duration = 400) => {
                            element.style.opacity = 0;
                            element.style.display = 'block';
                            let start = performance.now();

                            const animate = (time) => {
                                const elapsed = time - start;
                                const progress = Math.min(elapsed / duration, 1);
                                element.style.opacity = progress;

                                if (progress < 1) {
                                    requestAnimationFrame(animate);
                                } else {
                                    currentParent.classList.add(mClass);
                                }
                            };

                            requestAnimationFrame(animate);
                        };

                        fadeIn(currentSubmenu);
                    } else {
                        const currentSubmenu = currentParent.querySelector('ul.sub-menu');
                        const fadeOut = (element, duration = 400) => {
                            let start = performance.now();
                            const initialOpacity = parseFloat(getComputedStyle(element).opacity);

                            const animate = (time) => {
                                const elapsed = time - start;
                                const progress = Math.min(elapsed / duration, 1);
                                element.style.opacity = initialOpacity - progress * initialOpacity;

                                if (progress < 1) {
                                    requestAnimationFrame(animate);
                                } else {
                                    element.style.display = 'none';
                                    currentParent.classList.remove(mClass);
                                }
                            };

                            requestAnimationFrame(animate);
                        };

                        fadeOut(currentSubmenu);
                    }
                });
            });
        }

        if (parent) {
            parent.forEach(p => {
                const link = p.querySelector('a');
                if (link) {
                    link.addEventListener('click', function (e) {
                        if (this.getAttribute('href') === 'javascript:;') {
                            const currentParent = this.closest('li.menu-item-has-children');

                            if (!currentParent.classList.contains('open')) {
                                parent.forEach(p => {
                                    p.classList.remove(mClass);
                                    p.querySelectorAll('ul.sub-menu').forEach(s => {
                                        s.style.display = 'none';
                                    });
                                });

                                const currentSubmenu = currentParent.querySelector('ul.sub-menu');

                                // Simulazione fadeIn
                                const fadeIn = (element, duration = 400) => {
                                    element.style.opacity = 0;
                                    element.style.display = 'block';
                                    let start = performance.now();

                                    const animate = (time) => {
                                        const elapsed = time - start;
                                        const progress = Math.min(elapsed / duration, 1);
                                        element.style.opacity = progress;

                                        if (progress < 1) {
                                            requestAnimationFrame(animate);
                                        } else {
                                            currentParent.classList.add(mClass);
                                        }
                                    };

                                    requestAnimationFrame(animate);
                                };

                                fadeIn(currentSubmenu);
                            } else {
                                const currentSubmenu = currentParent.querySelector('ul.sub-menu');

                                // Simulazione fadeOut
                                const fadeOut = (element, duration = 400) => {
                                    let start = performance.now();
                                    const initialOpacity = parseFloat(getComputedStyle(element).opacity);

                                    const animate = (time) => {
                                        const elapsed = time - start;
                                        const progress = Math.min(elapsed / duration, 1);
                                        element.style.opacity = initialOpacity - progress * initialOpacity;

                                        if (progress < 1) {
                                            requestAnimationFrame(animate);
                                        } else {
                                            element.style.display = 'none';
                                            currentParent.classList.remove(mClass);
                                        }
                                    };

                                    requestAnimationFrame(animate);
                                };

                                fadeOut(currentSubmenu);
                            }
                        }
                    });
                }
            });
        }
    }
};

const bouncingMenu = () => {
    if (globalVar.is_desktop) {
        // overlay (SVG path element)
        const overlayPath = document.querySelector('.overlay__path');

        // menu (wrap) element
        const menuWrap = document.querySelector('#menu_sidebar_wrap');

        // menu items
        const menuItems = document.querySelectorAll('.menu_sidebar_inner_left ul.menu > li > a');

        // open menu button
        const openMenuCtrl = document.querySelector('#open_menu');

        // close menu button
        const closeMenuCtrl = document.querySelector('#close_menu');

        let isAnimating = false;

        // opens the menu
        const openMenu = () => {
            if (isAnimating) return;
            isAnimating = true;
            gsap.timeline({
                onComplete: () => isAnimating = false
            })
                .set(document.body, {
                    overflow: 'hidden',
                })
                .set(overlayPath, {
                    attr: {d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z'}
                })
                .to(overlayPath, {
                    duration: 0.8,
                    ease: 'power4.in',
                    attr: {d: 'M 0 100 V 50 Q 50 0 100 50 V 100 z'}
                }, 0)
                .to(overlayPath, {
                    duration: 0.3,
                    ease: 'power2',
                    attr: {d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z'},
                    onComplete: () => {
                        menuWrap.classList.add('menu-wrap--open');
                    }
                })
                // now reveal
                .set(menuItems, {
                    opacity: 0
                })
                .set(overlayPath, {
                    attr: {d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z'}
                })
                .to(overlayPath, {
                    duration: 0.3,
                    ease: 'power2.in',
                    attr: {d: 'M 0 0 V 50 Q 50 0 100 50 V 0 z'}
                })
                .to(overlayPath, {
                    duration: 0.8,
                    ease: 'power4',
                    attr: {d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z'}
                })
                // menu items translate animation
                .to(menuItems, {
                    duration: 1.1,
                    ease: 'power4',
                    startAt: {y: 150},
                    y: 0,
                    opacity: 1,
                    stagger: 0.05
                }, '>-=1.1');
        };

        // closes the menu
        const closeMenu = () => {
            if (isAnimating) return;
            isAnimating = true;
            gsap.timeline({
                onComplete: () => isAnimating = false
            })
                .set(overlayPath, {
                    attr: {d: 'M 0 0 V 0 Q 50 0 100 0 V 0 z'}
                })
                .to(overlayPath, {
                    duration: 0.8,
                    ease: 'power4.in',
                    attr: {d: 'M 0 0 V 50 Q 50 100 100 50 V 0 z'}
                }, 0)
                .to(overlayPath, {
                    duration: 0.3,
                    ease: 'power2',
                    attr: {d: 'M 0 0 V 100 Q 50 100 100 100 V 0 z'},
                    onComplete: () => {
                        menuWrap.classList.remove('menu-wrap--open');
                    }
                })
                // now reveal
                .set(overlayPath, {
                    attr: {d: 'M 0 100 V 0 Q 50 0 100 0 V 100 z'}
                })
                .to(overlayPath, {
                    duration: 0.3,
                    ease: 'power2.in',
                    attr: {d: 'M 0 100 V 50 Q 50 100 100 50 V 100 z'}
                })
                .to(overlayPath, {
                    duration: 0.8,
                    ease: 'power4',
                    attr: {d: 'M 0 100 V 100 Q 50 100 100 100 V 100 z'}
                })
                // menu items translate animation
                .to(menuItems, {
                    duration: 0.8,
                    ease: 'power2.in',
                    y: 100,
                    opacity: 0,
                    stagger: -0.05
                }, 0)
                .set(document.body, {
                    overflow: 'inherit',
                });
        };

        // click on menu button
        openMenuCtrl.addEventListener('click', openMenu);
        // click on close menu button
        closeMenuCtrl.addEventListener('click', closeMenu);
    } else {
        const link = document.querySelector('#open_menu');
        const wrap = document.querySelector('#menu_sidebar_wrap_mobile');
        const close = wrap ? wrap.querySelector('.close_sidebar') : null;

        if (link && wrap) {
            link.addEventListener('click', () => {
                wrap.classList.add('open');
            });

            if (close) {
                close.addEventListener('click', () => {
                    wrap.classList.remove('open');
                });
            }
        }
    }
}

const patternMenuAnimation = () => {
    const pattern = document.querySelector('.pattern');
    if (pattern) {
        gsap.to(pattern, {rotation: "360", duration: 150, ease: 'none', repeat: -1});
    }
}

const swipeImageHoverMenu = () => {
    const menuItems = document.querySelectorAll('#menu_sidebar_wrap .menu_sidebar_inner_left div[class^="menu-primary"] ul > li a');
    const firstImgItem = document.querySelector('#menu_sidebar_wrap .menu_sidebar_inner_right .container_feature_img .feature_image:first-child');
    const imgItems = document.querySelectorAll('#menu_sidebar_wrap .menu_sidebar_inner_right .container_feature_img .feature_image');

    if (firstImgItem) {
        firstImgItem.classList.add('image-active');
    }

    menuItems.forEach(item => {
        item.addEventListener('mouseenter', function() {
            const idImgMenuItem = this.getAttribute('data-img');
            const imgItem = document.querySelector('#menu_sidebar_wrap .menu_sidebar_inner_right .container_feature_img #' + idImgMenuItem);

            if (imgItem) {
                imgItems.forEach(img => img.classList.remove('image-active'));
                imgItem.classList.add('image-active');
            }

            this.addEventListener('mouseleave', function() {
                if (imgItem) {
                    imgItem.classList.add('image-active');
                }
            });
        });

        item.addEventListener('mouseleave', function() {
            imgItems.forEach(img => img.classList.remove('image-active'));
        });
    });

    if (imgItems.length > 0) {
        imgItems.forEach(element => {
            const tl2 = gsap.timeline({paused: true, ease: "power3.inOut"});
            tl2.fromTo(element, {
                x: -50,
                opacity: 0,
            }, {
                duration: 0.3,
                delay: 0.3,
                x: 0,
                opacity: 1,
            });

            if (element.classList.contains('image-active')) {
                tl2.play();
            }

            menuItems.forEach(item => {
                item.addEventListener('mousemove', function() {
                    if (element.classList.contains('image-active')) {
                        tl2.play();
                    } else {
                        tl2.reverse();
                    }
                });
            });
        });
    }
}

const sidebarSocial = () => {
    const socials = document.querySelectorAll('#sidebar-social a span');
    const slideshow = document.querySelector('#slideshow-1');

    if (globalVar.is_desktop && socials.length > 0 && slideshow) {
        let changeColor = gsap.timeline({
            scrollTrigger: {
                trigger: "#slideshow-1",
                pin: false,
                start: "top top",
                scrub: 1,
                snap: {
                    snapTo: "labels",
                    duration: {min: 0.2, max: 3},
                    delay: 0.2,
                    ease: "power1.inOut"
                }
            }
        });

        changeColor.fromTo(socials, {color: '#B17E49'}, {color: '#000'});
    }
}

const parallaxElements = () => {
    if (document.querySelector('.rellax')) {
        const rellax = new Rellax('.rellax');
    }
}

const selectSlimFixScroll = () => {
    setTimeout(function () {
        const list = document.querySelectorAll('.ss-content');
        if (list) {
            list.forEach((item) => {
                item.setAttribute('data-lenis-prevent', '');
            });
        }
    }, 500);
}

//--------------------------- BOOKING FORM -------------------------//
const slideshowSection = document.querySelector('#slideshow-1');
const bookingformInline = slideshowSection ? slideshowSection.querySelector('#bookingform-inline') : null;
const bookingformSidebar = document.querySelector('#bookingform-sidebar');
const inputsHidden = {
    hotel: document.querySelector('input[type="hidden"][name="hotel"]'),
    dateArrival: document.querySelector('input[type="hidden"][name="date-arrival"]'),
    dateDeparture: document.querySelector('input[type="hidden"][name="date-departure"]'),
    adults: document.querySelector('input[type="hidden"][name="adults"]'),
    children: document.querySelector('input[type="hidden"][name="children"]'),
};

//Datepicker calendar languages
const flatpickrLocales = {
    en: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday",
            ],
        },
        months: {
            shorthand: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec",
            ],
            longhand: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
        },
        ordinal: function (nth) {
            var s = nth % 100;
            if (s > 3 && s < 21)
                return "th";
            switch (s % 10) {
                case 1:
                    return "st";
                case 2:
                    return "nd";
                case 3:
                    return "rd";
                default:
                    return "th";
            }
        },
        rangeSeparator: " / ",
        weekAbbreviation: "Wk",
        scrollTitle: "Scroll to increment",
        toggleTitle: "Click to toggle",
        time_24hr: true,
    },
    pt: {
        firstDayOfWeek: 1,
        weekdays: {
            shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
            longhand: [
                "Domingo",
                "Segunda-feira",
                "Terça-feira",
                "Quarta-feira",
                "Quinta-feira",
                "Sexta-feira",
                "Sábado",
            ],
        },

        months: {
            shorthand: [
                "Jan",
                "Fev",
                "Mar",
                "Abr",
                "Mai",
                "Jun",
                "Jul",
                "Ago",
                "Set",
                "Out",
                "Nov",
                "Dez",
            ],
            longhand: [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro",
            ],
        },
        ordinal: function (nth) {
            if (nth > 1)
                return "";
            return "er";
        },
        rangeSeparator: " / ",
        weekAbbreviation: "Sem",
        scrollTitle: "Deslocar-se para aumentar o valor",
        toggleTitle: "Clique para alternar",
        time_24hr: true,
    }
};
const currentLocale = document.documentElement.lang.startsWith('pt') ? 'pt' : 'en';
const fpLocale = flatpickrLocales[currentLocale];

const bfHotels = () => {
    // Store SlimSelect instances for both forms to allow cross-form synchronization
    let slimSelectInline = null;
    let slimSelectSidebar = null;
    
    // Handle both inline and sidebar forms with synchronization
    const handleHotelsForm = (formElement, formType) => {
        if (!formElement) return;
        
        const hotels = formElement.querySelector('.bf__hotels');
        if (!hotels) return;
        
        const slimHotels = hotels.querySelector(`#bf__hotels--select-${formType}`);
        if (!slimHotels) return;
        
        const slimSelectHotels = new SlimSelect({
            select: slimHotels,
            settings: {
                showSearch: false,
                contentPosition: 'absolute',
                contentLocation: hotels,
                openPosition: formType === 'inline' ? 'up' : 'down'
            },
            events: {
                afterChange: () => {
                    const hotelSelected = slimSelectHotels.getSelected();
                    if (!hotelSelected || !hotelSelected.length) return;
                    
                    // Update the hidden input value
                    inputsHidden.hotel.value = hotelSelected[0];
                    
                    // Synchronize with the other form
                    if (formType === 'inline' && slimSelectSidebar && slimSelectSidebar.config && slimSelectSidebar.config.events) {
                        // Temporarily remove the onChange event to prevent infinite loop
                        const originalOnChange = slimSelectSidebar.config.events.afterChange;
                        slimSelectSidebar.config.events.afterChange = () => {};
                        
                        // Update sidebar form
                        slimSelectSidebar.setSelected(hotelSelected[0]);
                        
                        // Restore the onChange event after a short delay
                        setTimeout(() => {
                            slimSelectSidebar.config.events.afterChange = originalOnChange;
                        }, 0);
                    } else if (formType === 'sidebar' && slimSelectInline && slimSelectInline.config && slimSelectInline.config.events) {
                        // Temporarily remove the onChange event to prevent infinite loop
                        const originalOnChange = slimSelectInline.config.events.afterChange;
                        slimSelectInline.config.events.afterChange = () => {};
                        
                        // Update inline form
                        slimSelectInline.setSelected(hotelSelected[0]);
                        
                        // Restore the onChange event after a short delay
                        setTimeout(() => {
                            slimSelectInline.config.events.afterChange = originalOnChange;
                        }, 0);
                    }
                },
            }
        });
        
        // Store the SlimSelect instance for cross-form synchronization
        if (formType === 'inline') {
            slimSelectInline = slimSelectHotels;
        } else if (formType === 'sidebar') {
            slimSelectSidebar = slimSelectHotels;
        }
        
        return slimSelectHotels;
    };
    
    // Initialize both forms
    handleHotelsForm(bookingformInline, 'inline');
    handleHotelsForm(bookingformSidebar, 'sidebar');
}

const bfDate = () => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const dayAfterTomorrow = new Date(today);
    dayAfterTomorrow.setDate(today.getDate() + 2);
    
    // Store flatpickr instances to access them later for synchronization
    let inlineFlatpickr = null;
    let sidebarFlatpickr = null;
    
    // Function to format dates consistently
    const formatDates = (selectedDates) => {
        if (!Array.isArray(selectedDates) || selectedDates.length < 2) {
            console.warn('Both arrival and departure dates are needed');
            return null;
        }
        
        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        };
        
        return {
            arrival: selectedDates[0].toLocaleString('pt-PT', options),
            departure: selectedDates[1].toLocaleString('pt-PT', options),
            checkinDate: selectedDates[0].toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            checkoutDate: selectedDates[1].toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }),
            rawDates: selectedDates
        };
    };
    
    // Handle date picker for inline form (inline)
    const handleInlineDatePicker = () => {
        if (!bookingformInline) return;
        
        const bfDate = bookingformInline.querySelector('.bf__date');
        if (!bfDate) return;
        
        const checkinInput = bookingformInline.querySelector('#bf__date--checkin-inline');
        const checkoutInput = bookingformInline.querySelector('#bf__date--checkout-inline');
        if (!checkinInput) return;
        
        inlineFlatpickr = flatpickr(checkinInput, {
            mode: "range",
            showMonths: 2,
            minDate: "today",
            locale: fpLocale,
            dateFormat: "d-m-Y",
            defaultDate: [tomorrow, dayAfterTomorrow],
            static: true,
            plugins: [new rangePlugin({ input: "#bf__date--checkout-inline"})],
            onChange: (selectedDates) => {
                const formattedDates = formatDates(selectedDates);
                if (!formattedDates) return;
                
                // Update inline form inputs
                checkinInput.value = formattedDates.checkinDate;
                checkoutInput.value = formattedDates.checkoutDate;
                
                // Update hidden inputs
                inputsHidden.dateArrival.value = formattedDates.arrival;
                inputsHidden.dateDeparture.value = formattedDates.departure;
                
                // Synchronize with sidebar datepicker if it exists
                if (sidebarFlatpickr && bookingformSidebar) {
                    // Temporarily remove the onChange event to prevent infinite loop
                    const originalOnChange = sidebarFlatpickr.config.onChange;
                    sidebarFlatpickr.config.onChange = () => {};
                    
                    // Set the same dates in the sidebar datepicker
                    sidebarFlatpickr.setDate(formattedDates.rawDates);
                    
                    // Update sidebar inputs display format
                    const checkinSidebar = bookingformSidebar.querySelector('#bf__date--checkin-sidebar');
                    const checkoutSidebar = bookingformSidebar.querySelector('#bf__date--checkout-sidebar');
                    if (checkinSidebar && checkoutSidebar) {
                        checkinSidebar.value = formattedDates.checkinDate;
                        checkoutSidebar.value = formattedDates.checkoutDate;
                    }
                    
                    // Restore the original onChange event
                    setTimeout(() => {
                        sidebarFlatpickr.config.onChange = originalOnChange;
                    }, 0);
                }
            },
            onOpen: () => {
                const updateDatepickerPosition = () => {
                    const datepicker = document.querySelector('#bookingform-inline .flatpickr-calendar');

                    datepicker.classList.add('top');
                    datepicker.classList.remove('bottom');
                }

                updateDatepickerPosition();
                window.addEventListener('resize', updateDatepickerPosition);
            }
        });
    };
    
    // Handle date picker for sidebar form (sidebar)
    const handleSidebarDatePicker = () => {
        if (!bookingformSidebar) return;
        
        const bfDate = bookingformSidebar.querySelector('.bf__date');
        if (!bfDate) return;
        
        const checkinInput = bookingformSidebar.querySelector('#bf__date--checkin-sidebar');
        const checkoutInput = bookingformSidebar.querySelector('#bf__date--checkout-sidebar');
        if (!checkinInput || !checkoutInput) return;
        
        sidebarFlatpickr = flatpickr(checkinInput, {
            mode: "range",
            showMonths: 1,
            minDate: "today",
            locale: fpLocale,
            dateFormat: "d-m-Y",
            defaultDate: [tomorrow, dayAfterTomorrow],
            static: true,
            plugins: [new rangePlugin({input: "#bf__date--checkout-sidebar"})],
            onChange: (selectedDates) => {
                const formattedDates = formatDates(selectedDates);
                if (!formattedDates) return;
                
                // Format the date range for display in sidebar
                checkinInput.value = formattedDates.checkinDate;
                checkoutInput.value = formattedDates.checkoutDate;
                
                // Update hidden inputs
                inputsHidden.dateArrival.value = formattedDates.arrival;
                inputsHidden.dateDeparture.value = formattedDates.departure;
                
                // Synchronize with inline datepicker if it exists
                if (inlineFlatpickr && bookingformInline) {
                    // Temporarily remove the onChange event to prevent infinite loop
                    const originalOnChange = inlineFlatpickr.config.onChange;
                    inlineFlatpickr.config.onChange = () => {};
                    
                    // Set the same dates in the inline datepicker
                    inlineFlatpickr.setDate(formattedDates.rawDates);
                    
                    // Update inline inputs display format
                    const inlineCheckinInput = bookingformInline.querySelector('#bf__date--checkin-inline');
                    const inlineCheckoutInput = bookingformInline.querySelector('#bf__date--checkout-inline');
                    if (inlineCheckinInput && inlineCheckoutInput) {
                        inlineCheckinInput.value = formattedDates.checkinDate;
                        inlineCheckoutInput.value = formattedDates.checkoutDate;
                    }
                    
                    // Restore the original onChange event
                    setTimeout(() => {
                        inlineFlatpickr.config.onChange = originalOnChange;
                    }, 0);
                }
            },
            onOpen: () => {
                // Position the datepicker properly for sidebar
                const updateDatepickerPosition = () => {
                    const datepicker = document.querySelector('#bookingform-sidebar .flatpickr-calendar');
                    const target = document.querySelector('#bookingform-sidebar .bf__date');
                    if (!datepicker || !target) return;
                    
                    let targetRect = target.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const spaceBelow = viewportHeight - targetRect.bottom;
                    const spaceAbove = targetRect.top;

                    if (spaceAbove > spaceBelow) {
                        datepicker.classList.add('top');
                        datepicker.classList.remove('bottom');
                    } else {
                        datepicker.classList.remove('top');
                        datepicker.classList.add('bottom');
                    }
                }

                updateDatepickerPosition();
                window.addEventListener('resize', updateDatepickerPosition);
            },
            onClose: function () {
                const bfDate = document.querySelector('#bookingform-sidebar .bf__date');
                if (bfDate) bfDate.classList.remove('active');
            }
        });
    };
    
    // Initialize both date pickers
    handleInlineDatePicker();
    handleSidebarDatePicker();
}

const bfPersons = () => {
    // Store form elements for synchronization
    let inlineElements = null;
    let sidebarElements = null;
    let syncInProgress = false;
    
    // Handle persons counter for both forms
    const handlePersonsCounter = (formElement, formType) => {
        if (!formElement) return;
        
        const container = formElement.querySelector('.bf__persons');
        if (!container) return;
        
        const elements = {
            adultsCounter: formElement.querySelector('#bf__persons--stepper-counter-adults'),
            childrenCounter: formElement.querySelector('#bf__persons--stepper-counter-children'),
            adultStepperMinus: formElement.querySelector('.bf__persons--stepper-minus'),
            adultStepperPlus: formElement.querySelector('.bf__persons--stepper-plus')
        };
        
        if (!elements.adultsCounter || !elements.adultStepperMinus || !elements.adultStepperPlus) return;
        
        // Store elements for cross-form synchronization
        if (formType === 'inline') {
            inlineElements = elements;
        } else if (formType === 'sidebar') {
            sidebarElements = elements;
        }
        
        const updateHiddenInputs = () => {
            if (syncInProgress) return; // Prevent recursive updates
            
            inputsHidden.adults.value = elements.adultsCounter.value;
            
            // For sidebar form, also update the display text
            if (formElement === bookingformSidebar) {
                const adultsDisplay = formElement.querySelector('.bf__persons--adults');
                if (adultsDisplay) {
                    adultsDisplay.textContent = elements.adultsCounter.value;
                }
            }
            
            // Synchronize with the other form
            syncWithOtherForm(elements.adultsCounter.value, formType);
        };
        
        const handleStepper = (increment) => {
            let value = parseInt(elements.adultsCounter.value);
            const maxValue = 4; // Maximum 4 adults
            value = increment ? Math.min(value + 1, maxValue) : Math.max(value - 1, 1);
            elements.adultsCounter.value = value;
            updateHiddenInputs();
        };
        
        // Event Listeners
        elements.adultStepperMinus.addEventListener('click', () => handleStepper(false));
        elements.adultStepperPlus.addEventListener('click', () => handleStepper(true));
        
        // Initial update
        updateHiddenInputs();
        
        // For sidebar form, handle the tab toggle
        if (formElement === bookingformSidebar) {
            const personsButton = formElement.querySelector('#bf__persons--select-sidebar');
            const personsTab = formElement.querySelector('.bf__persons--tab');
            
            if (personsButton && personsTab) {
                personsButton.addEventListener('click', () => {
                    personsTab.style.opacity = '1';
                    personsTab.style.visibility = 'visible';
                });
                
                // Close the tab when clicking outside
                document.addEventListener('click', (e) => {
                    if (!container.contains(e.target) || e.target.closest('.bf__persons--stepper-vertical')) {
                        personsTab.style.opacity = '0';
                        personsTab.style.visibility = 'hidden';
                    }
                });
            }
        }
        
        return elements;
    };
    
    // Function to synchronize between forms
    const syncWithOtherForm = (value, sourceFormType) => {
        syncInProgress = true;
        
        try {
            if (sourceFormType === 'inline' && sidebarElements) {
                // Update sidebar form
                sidebarElements.adultsCounter.value = value;
                
                // Update sidebar display text
                const adultsDisplay = bookingformSidebar.querySelector('.bf__persons--adults');
                if (adultsDisplay) {
                    adultsDisplay.textContent = value;
                }
            } else if (sourceFormType === 'sidebar' && inlineElements) {
                // Update inline form
                inlineElements.adultsCounter.value = value;
            }
        } finally {
            // Always reset the sync flag
            setTimeout(() => {
                syncInProgress = false;
            }, 0);
        }
    };
    
    // Initialize both forms
    handlePersonsCounter(bookingformInline, 'inline');
    handlePersonsCounter(bookingformSidebar, 'sidebar');
};

const bfBook = () => {
    const bfBookBtnInline = document.getElementById('bf__book-inline');
    const bfBookBtnSidebar = document.getElementById('bf__book-sidebar');

    const convertDateFormat = (dateString) => {
        const [day, month, year] = dateString.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    };

    const handleBookingClick = () => {
        const hotelID = (inputsHidden.hotel.value !== '') ? inputsHidden.hotel.value : null;
        console.log('hotel ID', hotelID);

        $AvailPro.openBookingEngine({
            maybeHotelID: hotelID,
            arrivalDate: convertDateFormat(inputsHidden.dateArrival.value),
            departureDate: convertDateFormat(inputsHidden.dateDeparture.value),
            selectedAdultCount: inputsHidden.adults.value,
            selectedChildCount: '0',
            selectedInfantCount: '0',
        });
    };

    if (bfBookBtnInline) {
        bfBookBtnInline.addEventListener('click', handleBookingClick);
    }

    if (bfBookBtnSidebar) {
        bfBookBtnSidebar.addEventListener('click', handleBookingClick);
    }
}

const bfSidebarHandle = () => {
    if (!bookingformSidebar) return;
    
    const openMobile = document.querySelector('#mobile_bar .mobile_bar__book_now');
    const openSidebar = document.querySelector('#main_book_wrapper a');
    const close = bookingformSidebar.querySelector('.bookingform__close');

    const tl = gsap.timeline({paused: true});
    tl.fromTo(bookingformSidebar, {autoAlpha: 0, xPercent: 100}, {autoAlpha: 1, xPercent: 0, duration: 0.4, ease: 'power2.inOut'});

    //Open from mobile button
    if (openMobile) {
        openMobile.addEventListener('click', () => {
            tl.restart();
            globalVar.lenis.stop();
        });
    }

    //Open from sidebar button (top-right cta)
    if (openSidebar) {
        openSidebar.addEventListener('click', () => {
            tl.restart();
        });
    }

    //Close button
    if (close) {
        close.addEventListener('click', () => {
            tl.reverse();
            globalVar.lenis.start();
        });
    }
    
    // Close when clicking outside the sidebar
    document.addEventListener('mouseup', (e) => {
        // Check if the sidebar is visible
        if (bookingformSidebar.style.opacity !== '0' && bookingformSidebar.style.visibility !== 'hidden') {
            // Check if the click is outside the sidebar
            if (!bookingformSidebar.contains(e.target) && 
                e.target !== openSidebar && 
                (openMobile ? e.target !== openMobile : true)) {
                tl.reverse();
                globalVar.lenis.start();
            }
        }
    });
}

//-------------------------------------------------------------------//

document.addEventListener('load', () => {
    refresh_size_queries();
});

//Initialize Lenis Smooth Scroll
globalVar.lenis = new Lenis({
    smoothWheel: true
});

function raf(time) {
    globalVar.lenis.raf(time);
    requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

document.addEventListener('DOMContentLoaded', () => {
    gsap.registerPlugin(ScrollTrigger);
    refresh_size_queries();
    parallaxElements();
    selectSlimFixScroll();
    headerPosition();
    hotel_languages();
    openingSidebarSubmenu();
    swipeImageHoverMenu();
    patternMenuAnimation()
    bouncingMenu();
    //sidebarSocial();

    //Bookingform
    bfHotels();
    bfDate();
    bfPersons();
    bfSidebarHandle();
    bfBook();

    window.lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy",
        threshold: 50
    });
});

window.addEventListener('smartresize', () => {
    refresh_size_queries();
    refresh_size_queries();
    footerApartmentsAccordion();
    ScrollTrigger.refresh();
});
